const invoicesIT = {
    "view": {
        "table": {
            "title": "La tua lista di fatture",
            "column": {
                "issueDate": "Data di emissione",
                "invoiceNumber": "Numero di fattura",
                "status": "Stato",
                "totalAmount": "Importo totale",
                "downloadPDF": "Scarica PDF",
                "whtStatement": "Dichiarazione WHT"
            },
            "label": {
                "notApplicable": "Non applicabile"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "button": {
                "download": "Scarica",
                "exportCSV": "Esporta CSV"
            }
        },
        "message": {
            "cantAddInvoices": "Purtroppo, attualmente non puoi aggiungere fatture. I dati del tuo conto fiscale o di pagamento non sono completamente completati. Per sbloccare questa funzione, contatta il nostro team di supporto.",
            "invoicingNotAvailable": "Genera fatture dal 3 al 22 di ogni mese. Si prega di notare che la generazione di fatture non è possibile dal 23 al 2 del mese successivo, poiché durante questo periodo vengono processati i pagamenti automatici. Grazie per la comprensione.",
            "generatingInvoices": "Non puoi aggiungere fatture al momento poiché hai fatture che sono attualmente in fase di generazione. Si prega di ricontrollare più tardi.",
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Si prega di <1>riprendere</1> il tuo abbonamento per usufruire di questa funzione.",
            "subscriptionUpgrade": "Il tuo attuale piano di abbonamento non supporta questa funzione. Si prega di <1>aggiornare</1> il tuo piano di abbonamento per usufruire di questa funzione."
        }
    },
    "add": {
        "title": "Aggiungi Fattura",
        "form": {
            "table": {
                "statements": {
                    "title": "Dichiarazioni disponibili per la fatturazione"
                }
            },
            "button": {
                "generateInvoice": "Genera Fattura"
            }
        },
        "message": {
            "success": "La fattura è stata aggiunta!",
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!",
            "noStatementAvailable": "Nessuna dichiarazione disponibile per la fatturazione.",
            "invoicingLimitNotReached": "Non puoi aggiungere fatture al momento poiché il totale da pagare è minore o uguale a <strong>0€</strong>."
        },
        "modal": {
            "header": "Aggiungi Fattura",
            "body": "Sei sicuro di voler creare una fattura per le dichiarazioni attualmente APERTE?"
        }
    }
};

export default invoicesIT;